import { BLEND_MODES, Sprite } from 'pixi.js'
import Layer from '@/scripts/canvas/Layer'
import { getRandomInt } from '@/scripts/utils/math'

export function addLights(layer: Layer, lights: { x: number; y: number; id: string }[]): void {
  const sprites: Sprite[] = []

  for (const light of lights) {
    const sprite = Sprite.from(`${light.id}.png`)
    sprite.position.set(light.x, light.y)
    sprite.zIndex = 2
    sprite.blendMode = BLEND_MODES.ADD
    sprite.eventMode = 'passive'

    if (light.id !== 'svetla_lampy') {
      sprite.visible = Math.random() > 0.4
      sprites.push(sprite)
    }

    layer.addChild(sprite)
  }

  // start the global toggler once after all lights are added
  startLightToggler(sprites)
}

function startLightToggler(lights: Sprite[]): void {
  const toggleLights = () => {
    const count = getRandomInt(2, 4)
    const randomLights = [...lights].sort(() => Math.random() - 0.5).slice(0, count)

    for (const light of randomLights) {
      light.visible = !light.visible
    }

    // schedule next toggle between 5–10 seconds
    const delay = getRandomInt(5000, 10000)
    setTimeout(toggleLights, delay)
  }

  toggleLights()
}
